/** @format */
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';

import { MarketContext } from '@toucan/client/global/market';

export const useTranslatedHref = (href: string) => {
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    const translatedHref = href
        .split('/')
        .reduce<string[]>((url, item) => {
            if (item === '') {
                return url;
            }

            return [...url, t(item, { ns: 'urls' })];
        }, [])
        .join('/');

    return `/${activeMarket.slug}/${translatedHref}`;
};
